import getApiUrl from "../helpers/getApiUrl";

const placeProxyBid =
  (
    amount: number,
    url: string,
    significantFields: any,
    expiryDate: string,
    isToUseAuthZero: boolean,
    accessToken: string | null
  ) =>
  async () => {
    let headers: HeadersInit = {
      "Content-Type": "application/json",
    };

    if (isToUseAuthZero && accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    } else if (
      !isToUseAuthZero &&
      process.env.ENVIRONMENT === "localhost" &&
      process.env.token
    ) {
      headers.Authorization = `Bearer ${process.env.token}`;
    }

    const body = {
      Amount: amount,
      CurrencyCode: "GBP",
      SignificantFields: significantFields,
      ExpiryDate: expiryDate,
    };

    const res = await fetch(getApiUrl(url, isToUseAuthZero), {
      method: "post",
      headers,
      body: JSON.stringify(body),
    });

    if (res.status > 200) {
      throw `${res.status} Could not place proxy bid`;
    }
    const response = await res.json();
    return response;
  };

export default placeProxyBid;
